<template>
  <AboutMenu
    :menu="[
      { name: '股票信息', url: '/relationship/stock' },
      { name: '公司公告', url: '/relationship/note' },
      { name: '社会责任', url: '/responsibility' },
    ]"
  />
</template>

<script>
import AboutMenu from "@/views/components/AboutMenu";

export default {
  components: {
    AboutMenu,
  },
};
</script>

<style lang="scss">
</style>